<div class="row tabla-seccion tabla-scroll mt-3 d-none d-xl-block">
    <div class="col-12">
        <div class="tabla card pb-3">
            <div class="p-3 pb-0">
                <p class="titulo text-left">
                    <strong class="underline">
                        Participación ciudadana con base en la Lista Nominal de las Casillas con Actas PREP Contabilizadas.
                    </strong>
                </p>
            </div>
            <div class="contenido max-500">
                <div class="container-fluid">
<!-- Títulos -->
                    <div class="row  text-center sticky-header table-header-est-background">
                        <div class="col-3 dis-flex py-2">
                            <p>
                                <strong>
                                    Casilla
                                </strong>
                            </p>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                                <strong>
                                    Total de Votos
                                    <span class="tooltip-outer"
                                      tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
                                      placement="top" show-delay="200">
                                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                                    </span>
                                </strong>
                            </p>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                                <strong>
                                    Lista Nominal
                                </strong>
                            </p>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                                <strong>
                                    Participación ciudadana
                                </strong>
                            </p>
                        </div>
                    </div>
<!-- Filas -->
                    <div class="row filas text-center" *ngFor="let casilla of _obtenerDatosService.participacion_table">
                        <div class="col-3 dis-flex">
                            <a *ngIf="casilla?.c1?.param" href="./{{contiendaActual}}/{{param}}/secciones/{{casilla?.c1?.seccion}}/casilla/{{casilla?.c1?.param}}"><b>{{casilla?.c1?.numero}} {{casilla?.c1?.text}}</b></a>
                            <a *ngIf="!casilla?.c1?.param"><b>{{casilla?.c1?.numero}} {{casilla?.c1?.text}}</b></a>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                                {{ casilla?.c4 }}
                            </p>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                              {{ casilla?.c3 }}
                            </p>
                        </div>
                        <div class="col-3 dis-flex">
                            <p>
                              {{ casilla?.c2 }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <p class="titulo text-left p-3">
                <strong>
                    El cálculo de Participación ciudadana puede rebasar el 100% si vota toda la ciudadanía en la Lista Nominal de una casilla; así como las representaciones de Partidos Políticos.
                </strong>
            </p>
        </div>
    </div>
</div>
